export default __webpack_public_path__ + "static/media/ICON14.dc544ddf.svg";